export const SET_PART_PAYMENT_LOADER = "SET_PART_PAYMENT_LOADER";
export const SET_PART_PAYMENT_LIST = "SET_PART_PAYMENT_LIST";
export const GET_PART_PAYMENT_LIST = "GET_PART_PAYMENT_LIST";
export const UPLOAD_PART_PAYMENT_FILE = "UPLOAD_PART_PAYMENT_FILE";
